import React from 'react';
import { Pill } from '../../../domain/status';
import { createUseStyles } from 'react-jss';
import { PrescriptionPreview } from './PrescriptionPreview';

const useStyles = createUseStyles({
    root: {
        display: 'inline-flex',
        flexDirection: 'row',
        gap: '1rem',
        '& > :nth-child(3n)': {
            transform: 'rotate(-2deg)',
        },
        '& > :nth-child(2n)': {
            transform: 'rotate(3deg)',
        },
    },
});

interface IPrescriptionsProps {
    availablePills: Pill[];
}


export const Prescriptions: React.FunctionComponent<IPrescriptionsProps> = (props) => {
    const styles = useStyles();

    return (
        <div>
            <div className={styles.root} id="prescriptionlist">
                {props.availablePills.map((pill, i) => (
                    <div key={i}>
                        <PrescriptionPreview pill={pill} />
                    </div>
                ))}
            </div>
        </div>
    );
};
